export const Statistics = {
  indexes: {
    candidates: 'Candidates',
    positions: 'Positions',
    optedOutCount: 'OptedOutCount',
  },
} as const;
